import { render, staticRenderFns } from "./boleto.vue?vue&type=template&id=4999109e&scoped=true&"
import script from "./boleto.vue?vue&type=script&lang=js&"
export * from "./boleto.vue?vue&type=script&lang=js&"
import style0 from "./boleto.vue?vue&type=style&index=0&id=4999109e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999109e",
  null
  
)

export default component.exports